import { withExtra } from '@koaly/with-extra';
import React, { useState } from 'react';
import { Drawer } from '../Drawer.js';

const DrawerWithToggle = withExtra(({ children, width, position, button, scrollLock }) => {
    const [show, setShow] = useState(false);
    const onClick = () => {
        setShow(!show);
    };
    const onClose = () => {
        setShow(false);
    };
    const drawerButton = React.cloneElement(button, { onClick });
    return (React.createElement(React.Fragment, null,
        drawerButton,
        React.createElement(Drawer, { isShown: show, width: width, position: position, onClose: onClose, hasScrollLock: scrollLock }, children)));
}, { name: 'DrawerWithToggle' });

export { DrawerWithToggle };
//# sourceMappingURL=DrawerWithToggle.js.map
